import * as AboutUsAboutUsUploads from "$lib/data/generated/uploads/about us/AboutUs/uploads.js";
import * as AboutUsFeaturesAboutUploads from "$lib/data/generated/uploads/about us/Features About/uploads.js";
import * as AboutUsPageBannerUploads from "$lib/data/generated/uploads/about us/PageBanner/uploads.js";
import * as AboutUsSideBySideUploads from "$lib/data/generated/uploads/about us/SideBySide/uploads.js";

export const uploads = {
  ...AboutUsAboutUsUploads.uploads,
  ...AboutUsFeaturesAboutUploads.uploads,
  ...AboutUsPageBannerUploads.uploads,
  ...AboutUsSideBySideUploads.uploads
};
